// <s-back-to-top>: "Back to top" (merchant 2026-10-30 redesign, NN/g: only on pages longer than 4 screens).
// - Floating (desktop/tablet ≥768px): a small warm-white circle, bottom-start, shown once the shopper has scrolled
//   past 1.5 screens of a page at least 4 screens tall.
// - [data-static] (phones): a quiet full-width "Back to top" row above the footer (Amazon / NYC design system: not
//   sticky on mobile, so it never fights the buy bar, cart bar or chat button). Shown only on pages ≥ 4 screens.
// Click smooth-scrolls to the top (instant with reduced motion) and moves focus to the main content.
class BackToTop extends HTMLElement {
  #abort = null;
  #frame = 0;

  connectedCallback() {
    const button = this.querySelector('button');
    if (!button) return;
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    const isStatic = this.hasAttribute('data-static');

    const update = () => {
      this.#frame = 0;
      const viewport = window.innerHeight;
      const isLong = document.documentElement.scrollHeight >= viewport * 4;
      if (isStatic) {
        this.hidden = !isLong;
        return;
      }
      const show = isLong && window.scrollY > viewport * 1.5;
      this.toggleAttribute('data-visible', show);
      button.tabIndex = show ? 0 : -1;
    };
    const schedule = () => { if (!this.#frame) this.#frame = requestAnimationFrame(update); };

    if (!isStatic) window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { signal });
    window.addEventListener('load', schedule, { signal, once: true });

    button.addEventListener('click', () => {
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      const main = document.querySelector('main') || document.body;
      if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
    }, { signal });

    update();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', BackToTop);
